<a class="skip-link" href="#ui-shell-main" (click)="skipToMain($event)">{{ skipLinkLabel() }}</a>

@if (layout.isHandset()) {
  <header class="topbar">
    <button
      type="button"
      class="topbar__menu-button"
      aria-label="Open navigation"
      [attr.aria-expanded]="layout.drawerOpen()"
      (click)="layout.toggleDrawer()"
    >
      <ui-icon name="menu" />
    </button>
    <span class="topbar__title">
      <ng-content select="[uiShellTitle]" />
    </span>
    <span class="topbar__actions">
      <ng-content select="[uiShellActions]" />
    </span>
  </header>
}

<div
  class="shell"
  [class.shell--rail]="layout.sidenavMode() === 'rail'"
  [class.shell--handset]="layout.isHandset()"
  [class.shell--drawer-open]="layout.drawerOpen()"
>
  <!-- While the handset drawer is closed it sits off-canvas: `inert` keeps it
       out of the tab order and away from assistive tech until it opens. While
       open, focus is captured and trapped inside until the drawer closes. -->
  <aside
    class="shell__sidenav"
    [cdkTrapFocus]="layout.isHandset() && layout.drawerOpen()"
    [cdkTrapFocusAutoCapture]="layout.isHandset() && layout.drawerOpen()"
    [attr.inert]="layout.isHandset() && !layout.drawerOpen() ? '' : null"
  >
    <ng-content select="ui-sidenav" />
  </aside>

  @if (layout.isHandset() && layout.drawerOpen()) {
    <div class="shell__backdrop" (click)="layout.closeDrawer()" aria-hidden="true"></div>
  }

  <main #main id="ui-shell-main" class="shell__main" tabindex="-1">
    <ng-content />
  </main>
</div>
